<template>
  <div style="display: flex; gap: 10px">
    <v-textarea
      :model-value="note"
      @update:model-value="$emit('update:note', $event)"
      label="NOTE"
      :rows="rows"
      no-resize
      style="width: 300px"
      hide-details
      variant="outlined"
    ></v-textarea>
    <v-textarea
      :model-value="noteRistampa"
      label="NOTE RISTAMPA"
      :rows="rows"
      no-resize
      style="width: 300px"
      hide-details
      variant="outlined"
      :readonly="true"
    ></v-textarea>
  </div>
</template>

<script>
export default {
  name: "NoteColloFields",
  props: {
    note: {
      type: String,
      default: "",
    },
    noteRistampa: {
      type: String,
      default: "",
    },
    rows: {
      type: Number,
      default: 5,
    },
  },
  emits: ["update:note"],
};
</script>
